import React, { Component, Fragment } from 'react';
import Breadcrumb from '../../common/breadcrumb';
//import data from '../../../assets/data/digital-category';
import Datatable_category from '../../common/datatable_category';
import Modal from 'react-responsive-modal';
import axios from 'axios'

export class Digital_category extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            categories: [],
            parentcategories: [],
            name: '',
            image: '',
            parentCategory: ''
        };
        this.addCategory = this.addCategory.bind(this);
        this.uploadFileHandler = this.uploadFileHandler.bind(this)
    }
    onOpenModal = () => {
        this.setState({ open: true });
    };

    onCloseModal = () => {
        this.setState({ open: false });
    };


    componentDidMount() {
        if (!localStorage.getItem('userInfo')) {
            window.location.href = '/admin';
        }

        fetch(`${process.env['REACT_APP_HOST']}/api/categories`)
            .then((response) => response.json())
            .then(result => {
                this.setState({ categories: result.categoryList });
            });

        fetch(`${process.env['REACT_APP_HOST']}/api/parentcategories`)
            .then((response) => response.json())
            .then(result => {
                console.log(result)
                this.setState({ parentcategories: result });

            });
    }

    editCategory(id) {
        // e.preventDefault();
        const url = `${process.env['REACT_APP_HOST']}/api/categories/${id}`;
        const params = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            // body: JSON.stringify({
            //     name: e.target.name.value,
            //     parentId: e.target.parentId.value,
            //     image: this.state.image
            // }),
        };
        // fetch(url, params)
        //     .then(response => response.json())
        //     .then(data => {
        //         console.log(data)
        //         window.location.reload(); 
        //     })
    }

    addCategory(e) {
        e.preventDefault();
        const url = `${process.env['REACT_APP_HOST']}/api/categories/`;
        console.log(e.target.name);
        console.log(e.target.parentId);

        const params = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                name: e.target.name.value,
                parentId: e.target.parentId.value,
                image: this.state.image,
                parentCategory: e.target.parentCategory.value
            }),
        };

        fetch(url, params)
            .then(response => response.json())
            .then(data => {
                console.log(data)
                window.location.reload();
            })
            // .catch(error => this.props.fetchError(error.message))
            ;
    }

    uploadFileHandler = async (e) => {
        const file = e.target.files[0]
        const formData = new FormData()
        formData.append('image', file)
        // setUploading(true)
        try {
            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }
            const { data } = await axios.post(`${process.env['REACT_APP_HOST']}/api/upload`, formData, config)
            this.setState({ image: data });
        } catch (error) {
            // console.log(error)
        }
    }

    deleteHandler = (id) => {
        if (window.confirm('Are you sure')) {
            const url = `${process.env['REACT_APP_HOST']}/api/categories/${id}`;
            const params = {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                }
            };
            fetch(url, params)
                .then(response => response.json())
                .then(data => {
                    // window.location.reload(); 
                })
        }
    }

    render() {
        const { open } = this.state;
        return (
            <Fragment>
                <Breadcrumb title="Categories" parent="Digital" />
                {/* <!-- Container-fluid starts--> */}
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                {/* <div className="card-header">
                                    <h5>Categories</h5>
                                </div> */}
                                <div className="card-body">
                                    <div className="btn-popup pull-right">
                                        <button type="button" className="btn btn-secondary" onClick={this.onOpenModal} data-toggle="modal" data-original-title="test" data-target="#exampleModal">Add Category</button>
                                        
                                        <Modal open={open} onClose={this.onCloseModal} >
                                            <div className="modal-header">
                                                <h5 className="modal-title f-w-600" id="exampleModalLabel2">Add Category</h5>
                                            </div>
                                            <div className="modal-body">
                                                <form method="post" action="#" onSubmit={this.addCategory}>
                                                    <div className="form-group">
                                                        <label className="col-form-label"><span>*</span>Parent Category</label>
                                                        <select className="custom-select" name="parentCategory" value={this.state.parentCategory} onChange={(e) => this.setState({ parentCategory: e.target.value })} >
                                                            {/* <option value="0">--Select--</option> */}

                                                            {this.state.parentcategories.map(category => (
                                                                <option value={category._id} >{category.name}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="recipient-name" className="col-form-label" >{this.props.name} Name :</label>
                                                        <input type="text" required="required" name="name" value={this.state.name} onChange={(e) => this.setState({ name: e.target.value })} className="form-control" />
                                                        <input type="hidden" name="parentId" value="0" />
                                                    </div>
                                                    {/* <div className="form-group">
                                                        <label htmlFor="image" className="col-form-label" >{this.props.image} Image :</label>
                                                        <input type="file" name="image" onChange={this.uploadFileHandler} className="form-control" required="required" />
                                                        
                                                    </div> */}

                                                    <div className="modal-footer">
                                                        <input type="submit" name="submit" value="Save" className="btn btn-primary" />
                                                        <button type="button" className="btn btn-secondary" onClick={() => this.onCloseModal('VaryingMdo')}>Close</button>
                                                    </div>
                                                </form>
                                            </div>

                                        </Modal>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div id="basicScenario" className="product-physical">

                                        <Datatable_category
                                            multiSelectOption={false}
                                            myData={this.state.categories}
                                            pageSize={10}
                                            pagination={true}
                                            class="-striped -highlight"
                                        />

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Container-fluid Ends--> */}
            </Fragment>
        )
    }
}

export default Digital_category
